import React from "react";
import { ShieldCheck, TrendUp, Sparkle } from "@phosphor-icons/react";
import { Seg, Section } from "./fields";

const SUGGEST = { tax_free_income: "iul", legacy: "iul", growth: "iul", lifetime_income: "fia", principal_protection: "fia" };

const Card = ({ id, active, suggested, icon: Icon, title, body, onPick }) => (
  <button type="button" data-testid={`ro-product-${id}`} onClick={() => onPick(id)}
    className={`text-left p-6 border transition-colors ${active ? "border-exodus-gold bg-exodus-gold/10" : "border-exodus-border bg-exodus-surface hover:border-exodus-gold/60"}`}>
    <div className="flex items-center justify-between">
      <Icon size={26} weight="thin" className="text-exodus-gold" />
      {suggested && <span data-testid={`ro-suggested-${id}`} className="text-[10px] eyebrow border border-exodus-gold/60 text-exodus-gold px-2 py-1 inline-flex items-center gap-1"><Sparkle size={10} />Fits your goal</span>}
    </div>
    <p className="font-display text-2xl mt-4">{title}</p>
    <p className="text-sm text-exodus-muted mt-2 leading-relaxed">{body}</p>
  </button>
);

export const StepProduct = ({ inputs, setTop, onScenario }) => (
  <div className="space-y-10">
    <Section title="Destination product">
      <div className="grid md:grid-cols-2 gap-4">
        <Card id="iul" active={inputs.product === "iul"} suggested={SUGGEST[inputs.client.goal] === "iul"} icon={TrendUp} onPick={(v) => setTop({ product: v })}
          title="Indexed Universal Life" body="Life insurance with a cash value that earns index-linked credits with a 0% floor. Income comes later as tax-free policy loans. Moving pre-tax money in is a taxable distribution." />
        <Card id="fia" active={inputs.product === "fia"} suggested={SUGGEST[inputs.client.goal] === "fia"} icon={ShieldCheck} onPick={(v) => setTop({ product: v })}
          title="Fixed Indexed Annuity" body="A direct, tax-deferred rollover into an IRA annuity. Principal is protected from market loss, and an optional income rider pays for life." />
      </div>
    </Section>
    <Section title="Illustration scenario">
      <Seg testid="ro-scenario" label="Assumption set" value={inputs.scenario} onChange={onScenario}
        hint="Picking a scenario loads that preset's caps, charges and returns. You can edit every number on the next step."
        options={[{ v: "conservative", label: "Conservative" }, { v: "baseline", label: "Baseline" }, { v: "aggressive", label: "Aggressive" }]} />
    </Section>
  </div>
);
